import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { RoleStatus } from '../types';

interface RoleStatusBadgeProps {
  status: RoleStatus;
  className?: string;
}

export function RoleStatusBadge({ status, className }: RoleStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      className={`rounded-full ${className || ''}`}
      variant={
        status === 'ARCHIVED'
          ? 'secondary'
          : status === 'ACTIVE'
          ? 'default'
          : 'secondary'
      }
    >
      {t(`status.${status}`)}
    </Badge>
  );
}
